import { Button, Loading } from "ui-library/atoms";

import i18n from "core/i18n";
import { InPageFormButtonsLayout } from "containers/inPageForm";

import useStepSignature from "../hooks/useStepSignature";

import { SignatureTypeSelection } from "./SignatureTypeSelection";
import { Recapitulation } from "./Recapitulation";

export default function StepSignature({ nextStep, previousStep }: { nextStep: () => void; previousStep: () => void }) {
    const { t } = i18n.useTranslation();
    const { editOperator, editOwner, validityStartDate, submit, isSubmitting } = useStepSignature(nextStep);

    return (
        <>
            <Recapitulation validityStartDate={validityStartDate} isOperatorEdited={editOperator} isOwnerEdited={editOwner} />

            <SignatureTypeSelection isDisabled={isSubmitting} />

            <InPageFormButtonsLayout
                leftButton={
                    <Button variant="outlined" color="blue" onClick={previousStep}>
                        {t("common.back")}
                    </Button>
                }
                rightButton={
                    <Button variant="contained" color="blue" onClick={submit} disabled={isSubmitting}>
                        {isSubmitting ? <Loading loading={true} /> : t("common.continue")}
                    </Button>
                }
            />
        </>
    );
}
